import { API } from './api.service'
import { removeEmptyString } from '../utils'

export default {
  register (credentials) {
    return API.post('/auth/register', credentials)
  },
  login (credentials) {
    return API.post('/auth/login', credentials)
  },
  validEmail (credentials) {
    return API.post('/users/confirm-email', credentials)
  }
}
